module.exports = __webpack_public_path__ + "img/image_2 - 副本.0722938f.png";